import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class GeolocationsService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private httpClient: HttpClient) { }

  getLocations(){
    return this.httpClient.get("/locations");
  }

  getCount(){
    return this.httpClient.get("/locations/count");
  }

  createLocation(data) {
    let body = JSON.stringify(data);
    return this.httpClient.post('/locations/', body, this.httpOptions);
  }

  updateLocation(data) {
    let body = JSON.stringify(data);
    return this.httpClient.put('/locations/' + data.id, body, this.httpOptions);
  }

  deleteLocation(data) {
    return this.httpClient.delete('/locations/' + data.id);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/geolocations/geolocations.service.ts